module.exports = __webpack_public_path__ + "static/media/objective.d381ae34.svg";